<template>
    <div>
    </div>
</template>
<script>
import { onMounted } from 'vue'
import {getGoodList} from '../http/api'

export default {
    setup(){
        onMounted(()=>{
            getGoodList().then(res=>{
                console.log(res)
            })
        })
    }
}
</script>